<template>
    <v-menu offset-y persistent permanent content-class="mt-2" :close-on-content-click="false">
        <template v-slot:activator="{ on, attrs }">
            <v-text-field
                outlined
                dense
                hide-details
                v-model="input"
                :v-validate="validation"
                :error-messages="errorMsgs"
                :label="label"
                :data-vv-name="label"
                :data-vv-as="label"
                placeholder="dd/mm/yyyy"
                mask="##/##/####"
                v-mask="'##/##/####'"
                append-icon="mdi-calendar"
            >
                <template v-slot:append>
                    <transition name="fade">
                        <v-btn v-if="dateRange" class="rpd-datepicker-btn mr-1" icon @click="clearDate"><v-icon>mdi-close</v-icon></v-btn>
                    </transition>
                    <v-btn class="rpd-datepicker-btn" icon v-on="on"><v-icon>mdi-calendar</v-icon></v-btn>
                </template>
            </v-text-field>
        </template>
        <v-date-picker
            style="width: 100%;" 
            v-model="dateRange"
            persistent
        ></v-date-picker>
    </v-menu>
</template>

<script>
import { mask } from 'vue-the-mask';

export default {
    props: {
        value: { // Accept `v-model` value
            type: String,
            default: ''
        },
        errorMsgs: {
            type: Array,
            default: () => []
        },
        label: {
            type: String,
            default: 'Amount'
        },
        validation: {
            type: String,
            default: ''
        },
    },
    directives: {
        mask,
    },
    data() {
        return {
            input: this.value, // Initialize input with prop value
            dateRange: null, // Internal date range
        };
    },
    watch: {
        input(newVal) {
            this.$emit('input', newVal); // Sync with parent
        },
        dateRange(newDate) {
            if (newDate) {
                // Convert YYYY-MM-DD to DD/MM/YYYY
                this.input = newDate.split('-').reverse().join('/');
            } else {
                this.input = '';
            }
            this.$emit('input', this.input);
        },
        value(newVal) {
            this.input = newVal; // Update local input if parent changes
        }
    },
    methods: {
        clearDate() {
            this.dateRange = null;
            this.input = '';
            this.$emit('input', ''); // Notify parent of cleared value
        }
    }
};
</script>